export default __webpack_public_path__ + "static/media/Youtube.9a60370a.svg";